import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import api from '../../api';
import OpenScheduleVariancesTable from '../OpenScheduleVariancesTable';

/**
 * The selected team's Open schedule variances. Not tied to the date window:
 * an open variance needs actioning whenever it happened.
 */
export default function ScheduleVariancesTab({ teamId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!teamId) { setRows([]); return; }
    setLoading(true);
    api.get('/api/schedule-variances', { params: { status: 'Open', team_id: teamId } })
      .then((r) => setRows(r.data || []))
      .catch(() => { setRows([]); message.error('Failed to load schedule variances.'); })
      .finally(() => setLoading(false));
  }, [teamId]);

  return <OpenScheduleVariancesTable rows={rows} loading={loading} pageSize={25} />;
}
